import { CheckIcon } from '@heroicons/react/20/solid'

export const titles = [
    {name: 'Información básica'},
    {name: 'Otros datos'},
    {name: 'Revisar oferta'},
    {name: 'Firmar documentos'},
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function Steps(props) {
    const steps = [
        { name: titles[0].name, status: props.estado1},
        { name: titles[1].name, status: props.estado2 },
        { name: titles[2].name, status: props.estado3 },
        { name: titles[3].name, status: props.estado4 }
    ]
    
    return (
        <nav aria-label="Progress">
            <ol role="list" className="flex pt-36 justify-center">
                {steps.map((step, stepIdx) => (
                    <div key={`${stepIdx}-divroot`}>
                        <li key={step.name} className={classNames(stepIdx !== steps.length - 1 ? 'pr-14 sm:pr-24 md:pr-48 lg:pr-64' : '', 'relative')}>
                            {step.status === 'complete' ? (
                                <>
                                    <div key={stepIdx} className=''>
                                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                            <div className="h-0.5 w-full bg-purple" />
                                        </div>
                                        <a
                                            className="relative w-8 h-8 flex items-center justify-center bg-purple rounded-full"
                                        >
                                            <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" />
                                            <span className="sr-only">{step.name}</span>
                                        </a>
                                    </div>
                                </>
                            ) : step.status === 'current' ? (
                                <>
                                    <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                        <div className="h-0.5 w-full bg-purple" />
                                    </div>
                                    <a
                                        className="relative w-8 h-8 flex items-center justify-center bg-white border-2 border-purple rounded-full"
                                        aria-current="step"
                                    >
                                        <span className="h-2.5 w-2.5 bg-purple rounded-full" aria-hidden="true" />
                                        <span className="sr-only">{step.name}</span>
                                    </a>
                                </>
                            ) : (
                                <>
                                    <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                        <div className="h-0.5 w-full bg-purple" />
                                    </div>
                                    <a
                                        className="group relative w-8 h-8 flex items-center justify-center bg-white border-2 border-purple rounded-full"
                                    >
                                        <span
                                            className="h-2.5 w-2.5 bg-transparent rounded-full"
                                            aria-hidden="true"
                                        />
                                        <span className="sr-only">{step.name}</span>
                                    </a>
                                </>
                            )}
                        </li>
                    </div>
                ))}
            </ol>
            <div className='hidden md:block lg:px-24'>
                <div className='justify-center grid grid-cols-8 '>
                    {steps.map((step) => (
                        <div key={step.name} className='col-span-2 text-center'>
                            <span className='' >{step.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </nav>
    )
}
